class QuickAddDropdown extends HTMLElement {
	static CLASSES = {
		ACTIVE: 'quick-add__dropdown--active',
		SELECTED_OPTION: 'quick-add__option--selected',
	};
	constructor() {
		super();
		this.active = false;
		this.elements = {
			control: this.querySelector('.quick-add__control'),
			head: this.querySelector('.quick-add__head'),
			menu: this.querySelector('.quick-add__menu'),
			selectedLabel: this.querySelector('.quick-add__selected-variant'),
			selectedOption: this.querySelector(`.${QuickAddDropdown.CLASSES.SELECTED_OPTION}`),
		};
		this.attachEventListeners();
	}
	attachEventListeners() {
		const { head } = this.elements;
		head.addEventListener('click', this.toggle.bind(this));
		this.querySelectorAll('.quick-add__option').forEach((option) => {
			option.addEventListener('click', this.handleOptionSelect.bind(this));
		});
		document.addEventListener('click', (event) => {
			if (!this.contains(event.target)) this.close();
		});
	}
	close() {
		if (!this.active) return;
		const { menu } = this.elements;
		this.active = false;
		this.classList.remove(QuickAddDropdown.CLASSES.ACTIVE);
		menu.ariaExpanded = 'false';
		menu.hidden = true;
	}
	handleOptionSelect(event) {
		if (!event) return;
		const option = event.currentTarget;
		this.selectOption(option);
		this.updateHead(option);
		this.updateProductCard(option);
		this.close();
	}
	open() {
		if (this.active) return;
		const { menu } = this.elements;
		this.active = true;
		this.classList.add(QuickAddDropdown.CLASSES.ACTIVE);
		menu.ariaExpanded = 'true';
		menu.hidden = false;
	}
	selectOption(option) {
		if (!option) return;
		const { control, selectedOption } = this.elements;
		const selectedClass = QuickAddDropdown.CLASSES.SELECTED_OPTION;
		control.value = option.dataset.value;
		option.classList.add(selectedClass);
		selectedOption.classList.remove(selectedClass);
		this.elements.selectedOption = option;
	}
	toggle() {
		this.active ? this.close() : this.open();
	}
	updateProductCard(option) {
		const productCard = this.closest('product-card');
		if (!productCard || !option) return;
		productCard.setVariant(option);
	}
	updateHead(option) {
		if (!option) return;
		const { selectedLabel } = this.elements;
		selectedLabel.textContent = option.textContent;
	}
}

if (!customElements.get('quick-add-dropdown')) {
	customElements.define('quick-add-dropdown', QuickAddDropdown);
}
